module.exports = "/img/logo-pocket.png?45e59840e230c2f0bba9f1b5335ed15e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo-pocket.png
// module id = Q/Zf
// module chunks = 57